import { Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

export const BackgroundDivider = styled(Divider)(({ theme }) => ({
    backgroundColor: theme.dividers.backgroundDivider.backgroundColor,
}));

export const ContentDivider = styled(Divider)(({ theme }) => ({
    backgroundColor: theme.dividers.contentDivider.backgroundColor,
}));
